import React from 'react';
import { useTranslation } from "react-i18next";
import '../../assets/styles/TypingIndicator.css';

const TypingIndicator = () => {
    const { t } = useTranslation(['chatbot']);

    return (
        <div className="typing-container">
            <div className="typing-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 8V4H8"/>
                    <rect width="16" height="12" x="4" y="8" rx="2"/>
                    <path d="m14 8-2 2-2-2"/>
                    <path d="M4 14h16"/>
                </svg>
            </div>

            <div className="typing-bubble">
                <div className="typing-content">
                    <div className="typing-dots">
                        <div className="typing-dot" style={{ animationDelay: '0ms' }}></div>
                        <div className="typing-dot" style={{ animationDelay: '200ms' }}></div>
                        <div className="typing-dot" style={{ animationDelay: '400ms' }}></div>
                    </div>
                    <span className="typing-text">{t('chatbot.thinkingMessage')}</span>
                </div>
            </div>
        </div>
    );
};

export default TypingIndicator;